// extracted by mini-css-extract-plugin
export default {"Modal":"Modal_Modal__0qI+n","Modal__close":"Modal_Modal__close__ULKDa","Modal__back":"Modal_Modal__back__WwsjU","Modal__content":"Modal_Modal__content__H+kxS"};